/** @format */

import { combineReducers } from "redux";

import questionFormReducer from "./QuestionFormReducer";
import InterviewQuestionsReducer from "./InterviewQuestionsReducer";

export default combineReducers({
  questionFormReducer,
  interviewQuestions: InterviewQuestionsReducer,
});
